<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isShowGroupPrices ||
    isShowOrganizations ||
    isShowGroupPriceDetailAuditPage ||
    isShowGroupPriceAuditPage
      ? 'd-none'
      : ''
  "
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Audit btns ---------------->
  <div class="card-toolbar" before-btns>
    <!-- audit menu btn -->
    <a
      *ngIf="permissionService.userState()?.isSuperAdmin"
      [matMenuTriggerFor]="menu"
      class="btn btn-light txt-lg button-shadow tw-mx-1"
      type="button"
      mat-ripple
      [matTooltip]="'pages.audits.title' | translate"
    >
      <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
    </a>
    <mat-menu #menu="matMenu" xPosition="after">
      <!-- group price audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowAuditPage()"
      >
        <span class="tw-mx-1">{{
          pageVocabs + "groupPriceCategories.title" | translate
        }}</span>
      </a>

      <!-- group price audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowGroupPriceAuditPage()"
      >
        <span class="tw-mx-1">{{ pageVocabs + "title" | translate }}</span>
      </a>

      <!-- group price detail audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center"
        mat-ripple
        (click)="onShowGroupPriceDetailAuditPage()"
      >
        <span class="tw-mx-1">{{
          pageVocabs + "detailForm.title" | translate
        }}</span>
      </a>
    </mat-menu>
  </div>

  <!----------------------------------------- Table Content -------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- categoryName -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value copyToClipboard [value]="item?.categoryName"></td-value>
        </td>

        <!-- groupPriceCount -->
        <td class="large-text">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.groupPriceCount"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- copyGroupPrice button -->
            <div app-menu-btn icon="mdi mdi-content-copy mdi-20px" color="blue" [title]="tableVocabs + 'copyGroupPrice'"
              (click)="onCopy(item)"></div>

            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item, false)"></div>

            <!-- delete button -->
            <div app-menu-btn icon="delete" (click)="onDelete(item)"></div>

            <!-- show group price button -->
            <div app-menu-btn icon="mdi mdi-tag-multiple-outline mdi-20px" color="green" [title]="'common.rangeList'"
              (click)="onShowGroupPrices(item)"></div>

            <!-- show group price button -->
            <div app-menu-btn icon="mdi mdi-table-network mdi-20px" color="indigo" [title]="'common.organizations'"
              (click)="onShowOrganizations(item)"></div>

          </mat-menu>
        </td>
        
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- group price -->
<app-group-price
  *ngIf="isShowGroupPrices"
  [categoryId]="selectedCategoryId"
  [categoryName]="selectedCategoryName"
  (onClose)="onHideGroupPrices()"
>
</app-group-price>

<!-- group-price-organizations -->
<app-group-price-organizations
  *ngIf="isShowOrganizations"
  [organizationIds]="groupPriceOrganizations"
  [categoryId]="selectedCategoryId"
  (closeFormPage)="
    isShowOrganizations = false; showParent = true; getParentQueryString()
  "
>
</app-group-price-organizations>

<!-------------------------------------------- Audit ----------------------------------------->

<!--Group Price Categories -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--Group Price Audit -->
<ng-container *ngIf="isShowGroupPriceAuditPage">
  <app-audit
    [service]="groupPricesService"
    methodName="groupPricesGetGroupPricesAudit"
    (hidePage)="isShowGroupPriceAuditPage = false"
  >
  </app-audit>
</ng-container>

<!--Group Price Detail Audit -->
<ng-container *ngIf="isShowGroupPriceDetailAuditPage">
  <app-audit
    [service]="groupPriceDetailService"
    methodName="groupPriceDetailsGetGroupPriceDetailsAudit"
    (hidePage)="isShowGroupPriceDetailAuditPage = false"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="GroupPrices"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
